import { TextHeader } from '@components';
import { SimMetricsTable } from '@components/tables/SimMetricsTable';
import { ConvertMonth } from '@utils/dates/MonthEnum';
import React from 'react';

interface props {
  data: any;
}

export const SimMetricsContainer = ({ data }: props) => {
  return (
    <div>
      <TextHeader
        subtitle={data.period.year}
        title={ConvertMonth(data.period.month, true)}
      />
      <SimMetricsTable data={data.metrics} />
    </div>
  );
};
